import React from "react";

// Forked Gatsby default to not remount on switches between translated versions of the same page.
// eslint-disable-next-line import/prefer-default-export
export function replaceComponentRenderer({ props }) {
	const { pageResources } = props;
	return React.createElement(pageResources.component, { ...props });
}
